import { render, staticRenderFns } from "./modifier-group-details-translation-list.vue?vue&type=template&id=3d0ac502&scoped=true"
import script from "./modifier-group-details-translation-list.vue?vue&type=script&lang=js"
export * from "./modifier-group-details-translation-list.vue?vue&type=script&lang=js"
import style0 from "./modifier-group-details-translation-list.vue?vue&type=style&index=0&id=3d0ac502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ac502",
  null
  
)

export default component.exports